import React from 'react'

interface ImageModalProps {
  show: boolean
  onHide: () => void
  imageUrl: string
  filename?: string
}

const ImageModal: React.FC<ImageModalProps> = ({
  show,
  onHide,
  imageUrl,
  filename,
}) => {
  if (!show) return null

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
      onClick={onHide}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          width: '30%',
          margin: '1rem auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: '#2d2d2d',
            border: 'none',
            borderRadius: '16px',
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <div
            className="modal-header border-0 d-flex justify-content-between align-items-center"
            style={{
              backgroundColor: '#2d2d2d',
              padding: '1rem 1.5rem',
              minHeight: '60px',
            }}
          >
            <h5
              className="modal-title text-white m-0"
              style={{ fontSize: '18px' }}
            >
              {filename || 'Photo'}
            </h5>
            <button
              type="button"
              className="btn text-white"
              onClick={onHide}
              style={{
                fontSize: '16px',
                backgroundColor: 'transparent',
                border: 'none',
                color: 'white',
                opacity: 0.8,
                padding: '0.5rem 1rem',
              }}
            >
              Done
            </button>
          </div>

          {/* Body */}
          <div
            className="modal-body p-0"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
              marginBottom: 'clamp(0.5rem, 4vw, 2rem)',
            }}
          >
            <img
              src={imageUrl}
              alt={filename || 'Image'}
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                display: 'block',
                borderRadius: '8px',
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageModal
